import { House } from 'lucide-react';
import { BreadCrumb } from 'primereact/breadcrumb';
import { FC, Suspense } from 'react';
import { Link } from 'react-router-dom';
import { ThreeDotLoader } from '../../../Fallback/ThreeDotsLoader';
import StudentLearnExperience from './StudentLearnExperience';
import StudentLearnInteractive from './StudentLearnInteractive';
import StudentLearnOtherResources from './StudentLearnOtherResources';

const StudentLearnWrapper: FC = () => {
  const breadcrumbItems = [
    {
      template: () => <span className="tw-flex tw-font-atkinson tw-text-neutral-700">Guided Walkthroughs</span>,
    },
    {
      template: () => (
        <span className="tw-flex tw-font-atkinson tw-text-neutral-700 tw-font-bold">How students learn</span>
      ),
    },
  ];

  const home = {
    template: () => (
      <Link
        to={'/'}
        className="tw-flex tw-items-center tw-gap-2 tw-cursor-pointer tw-font-atkinson tw-text-neutral-700"
      >
        <House className="tw-text-blue-500" /> Home
      </Link>
    ),
  };

  return (
    <Suspense fallback={<ThreeDotLoader dark />}>
      <div style={{ overflowX: 'hidden' }} className={`nc_page-inner xl:tw-w-10/12 tw-mx-auto tw-w-11/12`}>
        <BreadCrumb model={breadcrumbItems} home={home} className="col-12 col-offset-0 tw-py-0" />
        <h1 className="tw-text-2xl tw-text-neutral-950 tw-font-sora tw-font-bold tw-my-6 tw-pb-4 tw-border-b-[2px] tw-border-t-[0px] tw-border-x-[0px] tw-border-neutral-100 tw-border-solid ">
          How students learn in Roadmaps
        </h1>
        <div className="tw-gap-y-6 tw-flex tw-flex-col">
          <StudentLearnExperience />
          <StudentLearnInteractive />
          <StudentLearnOtherResources />
        </div>
      </div>
    </Suspense>
  );
};

export default StudentLearnWrapper;
